import React from "react";
import PropTypes from "prop-types";
import Radium from "radium";
import AnimatedNumber from "react-animated-number";
import { POSITION, currencySymbols } from "../../utils/currency-position";
import { Tooltip } from "react-tooltip";
import numbro from "numbro";
import "./moneyDisplay.scss";

function MoneyDisplay(props) {
  const colorStyle = props.color ? { color: props.color } : {};

  const animatedNumberProps = {
    tooltip: "",
    component: "h5",
    initialValue: props.disableAnimation ? +props.value : 0,
    value: props.value || 0,
    style: {
      margin: 0,
      padding: 0,
      display: "inline",
      fontWeight: "100",
      transition: "0.8s ease-out",
      fontSize: props.size,
      ...colorStyle
    },
    ["data-testid"]: props.testId,
    className: "moneyDisplay",
    duration: 1000,
    stepPrecision: 1,
    formatValue: (n) => {
      const isPercent = props.currency === "%" && props.value > 0 && props.value < 1;

      const formatOptions = isPercent
        ? {
            output: "percent",
            mantissa: 1,
            trimMantissa: false
          }
        : {
            thousandSeparated: true,
            mantissa: props.decimal || 0,
            trimMantissa: false
          };

      const formatted = numbro(n).format(formatOptions);

      return formatted.replace("%", "");
    }
  };

  const renderCurrencySymbol = (position) => {
    const symbol = currencySymbols[props.currency];
    if (symbol === position || (!symbol && position === POSITION.START)) {
      return (
        <span
          className="money-display__symbol"
          style={{
            margin: 0,
            padding: 0,
            display: "inline-block",
            fontWeight: "100",
            transition: "0.8s ease-out",
            fontSize: props.size,
            ...colorStyle
          }}
        >
          <sup style={{ fontSize: "60%" }}>{props.currency}</sup>
        </span>
      );
    }
  };

  const tooltipId = props.toolTipId ? props.toolTipId : "data-point-tooltip";

  const display = (
    <span
      data-tooltip-html={props.toolTip}
      data-tooltip-id={tooltipId}
      style={{ display: "inline-block" }}
    >
      {renderCurrencySymbol(POSITION.START)}
      {props.url !== "" ? (
        <a style={styles.cta} href={props.url} target="_raw_data_tab">
          <AnimatedNumber {...animatedNumberProps} />
        </a>
      ) : (
        <AnimatedNumber {...animatedNumberProps} />
      )}
      {renderCurrencySymbol(POSITION.END)}
      {props.toolTip ? <Tooltip id={tooltipId} float /> : null}
    </span>
  );

  return props.label ? (
    <div>
      <h5 className="money-display__label">{props.label}</h5>
      {display}
    </div>
  ) : (
    display
  );
}

const styles = {
  cta: {
    textDecoration: "none"
  }
};

MoneyDisplay.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  toolTip: PropTypes.string,
  size: PropTypes.number,
  color: PropTypes.string,
  currency: PropTypes.string,
  url: PropTypes.string,
  testId: PropTypes.string,
  currencyLocation: PropTypes.string,
  decimals: PropTypes.number,
  disableAnimation: PropTypes.bool,
  toolTipId: PropTypes.string,
  label: PropTypes.string
};

MoneyDisplay.defaultProps = {
  value: 23,
  size: 46,
  currency: "",
  currencyLocation: "beginning",
  url: ""
};

export default Radium(MoneyDisplay);
